import BaseService from "../BaseService";
import _ from "lodash";

class DebtService extends BaseService {


    createDebt = async (debt) => {
        var data = await this._api.post("/debt/create_debt", debt);
        return data;
    };

    createPayment = async (payment) => {
        var data = await this._api.post("/debt/create_payment", payment);
        return data;
    };



    customerList = async (filter) => {
        var data = await this._api.post("/debt/customerlist", filter);
        return data;
    };

    listByCustomer = async (customer_id) => {
        var data = await this._api.post("/debt/list_by_customer", { customer_id: customer_id });
        return data;
    };


    delete = async (id) => {
        var data = await this._api.post("/debt/delete", { id: id });
        return data;
    };

    getByID = async (id) => {
        var data = await this._api.post("/debt/getbyid", { id: id });
        return data;
    };



    update = async (debt) => {
        var data = await this._api.post("/debt/update", debt);
        return data;
    };


    print = async (id, start) => {
        var data = await this._api.post("/debt/print", { id, start });
        return data;
    };

    getOrderForAllocation = async (id) => {
        var data = await this._api.post("/debt/get_order_for_allocation", { id });
        return data;
    };


    allocation = async (id, allocations) => {
        var data = await this._api.post("/debt/allocation", { id, allocations });
        return data;
    };















}
export default DebtService;
